export default "__VITE_ASSET__BpGnGVX8__"